"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const colors_1 = __importDefault(require("../colors"));
const listItem = {
    MuiListItem: {
        styleOverrides: {
            root: {
                wordBreak: "normal",
                whiteSpace: "normal",
                borderRadius: 0,
                "&:hover, &.Mui-selected": {
                    ".MuiListItemIcon--root": {
                        color: colors_1.default.primary[900],
                    },
                },
            },
        },
    },
    MuiListItemButton: {
        styleOverrides: {
            root: {
                borderLeft: `solid 2px ${colors_1.default.secondary[900]}`,
                "&:hover, &.Mui-selected": {
                    borderLeft: `solid 2px ${colors_1.default.primary[900]}`,
                    color: colors_1.default.primary[900],
                    svg: {
                        path: {
                            color: colors_1.default.primary[900],
                        },
                    },
                },
                "&:hover": {
                    backgroundColor: "rgba(255, 172, 60, 0.12)",
                },
            },
        },
    },
    MuiListItemIcon: {
        styleOverrides: {
            root: {
                fontSize: "0.9rem",
            },
        },
    },
};
exports.default = listItem;
